import { Link } from 'react-router-dom';
import { useState } from 'react';

interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  description: string;
  image: string;
}

const categories: CategoryItem[] = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '最新大片、经典老片，应有尽有',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20golden%20lighting%2C%20movie%20clapperboard%2C%20dramatic%20atmosphere%2C%20dark%20theater%20background%2C%20cinematic%20photography&width=400&height=300&seq=cat-dianying-01&orientation=landscape',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门剧集，追剧不停',
    image: 'https://readdy.ai/api/search-image?query=TV%20series%20collection%20with%20cozy%20living%20room%20setting%2C%20warm%20ambient%20lighting%2C%20modern%20entertainment%20vibe%2C%20comfortable%20atmosphere%2C%20home%20theater%20style&width=400&height=300&seq=cat-dianshiju-01&orientation=landscape',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺，欢笑不断',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20lights%20and%20energy%2C%20fun%20entertainment%20atmosphere%2C%20cheerful%20vibrant%20colors%2C%20game%20show%20vibe&width=400&height=300&seq=cat-zongyi-01&orientation=landscape',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-camera-lens-line',
    description: '探索世界，发现真相',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20wildlife%20and%20beautiful%20landscapes%2C%20professional%20camera%20equipment%2C%20adventure%20exploration%20vibe%2C%20earthy%20warm%20tones&width=400&height=300&seq=cat-jilupian-01&orientation=landscape',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '热血动漫，青春回忆',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20and%20animation%20art%20style%2C%20vibrant%20characters%2C%20dynamic%20composition%2C%20Japanese%20and%20Chinese%20animation%20vibe%2C%20creative%20fantasy%20world&width=400&height=300&seq=cat-dongman-01&orientation=landscape',
  },
];

export default function CategoryNav() {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1920px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900">
            视频分类
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            选择您感兴趣的分类，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl cursor-pointer"
              onMouseEnter={() => setHoveredIdx(idx)}
              onMouseLeave={() => setHoveredIdx(null)}
            >
              <div className="relative h-36 md:h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name}分类`}
                  className={`w-full h-full object-cover transition-transform duration-500 ${
                    hoveredIdx === idx ? 'scale-110' : 'scale-100'
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg mb-2">
                  <i className={`${cat.icon} text-white text-sm`}></i>
                </div>
                <h3 className="font-heading font-bold text-white text-base">{cat.name}</h3>
                <p className="text-xs text-white/70 mt-1 hidden sm:block">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}